import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { parseReportViewSearch } from '@core/reports/constants/reportSpaQueryParams';

type RequireReportQueryParamsProps = React.PropsWithChildren<{
  fallbackPath: string;
}>;

/**
 * Report detail pages require ?did= and ?tid= (tag id). No aliases.
 * Missing params redirect to the parent list route.
 */
export default function RequireReportQueryParams({
  fallbackPath,
  children,
}: RequireReportQueryParamsProps) {
  const [searchParams] = useSearchParams();
  const { departmentId, reportTagId } = parseReportViewSearch(searchParams);

  if (departmentId <= 0 || reportTagId <= 0) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
}
